module.exports = __webpack_public_path__ + "img/58.2aefce1.jpg";